module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABCklEQVQ4jZWTLUsEURSGn1H/gklQZKMYLNbF5K8wCDabwWIREQyCYFBsskX/gkkW0SSCQVBkwa9tBg2r9TF4B66XO+vMC8PlvHOew5kz5xYqiWaBZWABmAIK4A24ADrA9Z9sNX62/F97MRPDZzXgUldpge0GcKkjlUJtAb10EDU1PwKsNQAOgaUoXkd9rNnybvjczch7RR1Exr26kYF3Anyc+APU78h4DolzkbcSvPNM4S/UXmL2A7Aa2kXtZmDV/hjQBVrRYCaAd2A8xC/AZMVQbwp1BrjLvHwK5/SQv9IuF2m/osVhOjFZ5csG8K2Zu4B6UAPuqKNVBVDbIelB/VA//V22U3Uxzf8BTSWgZxiE1fYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/hollow-correct.png
// module id = L7Yr
// module chunks = 0